function getCookie(name) {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim()
    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.substring(name.length + 1))
    }
  }
  return ''
}

function getAuthToken() {
  return getCookie('AUTHORIZATION') || ''
}

function normalizePrefix(pathname) {
  if (!pathname || pathname === '/') return ''
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
}

function getWsEndpointConfig() {
  const isAppMode = process.env.VUE_APP_MODE === 'app'
  const isDev = process.env.NODE_ENV === 'development'

  if (isAppMode) {
    const customBase = localStorage.getItem('API_BASE_URL')
    if (customBase) {
      try {
        const url = new URL(customBase)
        const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
        return {
          origin: `${protocol}//${url.host}`,
          prefix: normalizePrefix(url.pathname),
        }
      } catch (e) {
        // ignore malformed custom url
      }
    }
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return {
    origin: `${protocol}//${window.location.host}`,
    // 开发环境默认通过 /api-proxy 走 devServer 代理到 Django
    prefix: !isAppMode && isDev ? '/api-proxy' : '',
  }
}

export function createAuthedWs(path, handlers = {}) {
  const token = encodeURIComponent(getAuthToken())
  const { origin, prefix } = getWsEndpointConfig()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const wsPath = `${prefix}${normalizedPath}`
  const wsUrl = `${origin}${wsPath}?token=${token}`
  const ws = new WebSocket(wsUrl)

  ws.onopen = () => {
    if (handlers.onOpen) handlers.onOpen()
  }

  ws.onclose = (evt) => {
    if (handlers.onClose) handlers.onClose(evt)
  }

  ws.onerror = (err) => {
    if (handlers.onError) handlers.onError(err)
  }

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data)
      if (handlers.onMessage) handlers.onMessage(msg)
    } catch (e) {
      // ignore malformed messages
    }
  }

  return ws
}

export function createSyncRoomWs(roomId, handlers = {}) {
  return createAuthedWs(`/ws/sync_room/${roomId}/`, handlers)
}

export function createTaskLogWs(logId, handlers = {}) {
  const suffix = logId ? `${logId}/` : ''
  return createAuthedWs(`/ws/task_logs/${suffix}`, handlers)
}
